module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 109.4 124.5"><path d="M106.4 57L9 .8C5-1.5 0 1.4 0 6v112.5c0 4.6 5 7.5 9 5.2l97.4-56.2c4-2.4 4-8.2 0-10.5z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/play-arrow.svg
// module id = 527
// module chunks = 1